import { render, staticRenderFns } from "./MoneyCard.vue?vue&type=template&id=37d90984&scoped=true&lang=pug&"
import script from "./MoneyCard.vue?vue&type=script&lang=js&"
export * from "./MoneyCard.vue?vue&type=script&lang=js&"
import style0 from "./MoneyCard.vue?vue&type=style&index=0&id=37d90984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d90984",
  null
  
)

export default component.exports